import React from 'react';

import Routes from '../../navigation/routes';

export default (WrappedComponent) => (props) => <WrappedComponent {...props} routes={Routes} />;
